import { render, staticRenderFns } from "./choosenft.vue?vue&type=template&id=430fda50&"
import script from "./choosenft.vue?vue&type=script&lang=js&"
export * from "./choosenft.vue?vue&type=script&lang=js&"
import style0 from "./choosenft.vue?vue&type=style&index=0&id=430fda50&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports